import React from 'react';

import { useNavigate } from 'react-router-dom';

import Layout from '../components/common/Layout';

const PreQualifiy = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="prequal-page">
        <div className="page-inner">
          <div>
            <h2>Congratulations! Your business is prequalified! What's next, you ask?</h2>
            <p>
              Go to MyLendistry to access your Lendistry account and submit any required documents
              that we need to continue our review process.
            </p>
            <p>
              When that's done, a Lendistry representative will contact you. Thank you for choosing
              Lendistry!
            </p>
            <button className="primary-btn" onClick={() => navigate('/dashboard')}>
              View account at MyLendistry
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PreQualifiy;
